import { toastr } from 'react-redux-toastr';
import adminUpdateBookingStatusMutation from './adminUpdateBookingStatus.gql';

export default function adminUpdateBookingStatus(bookingId, bookingStatus, driverId) {
  return async (dispatch, getState, { client }) => {

    try {
      let errorMessage;
      const mutation = adminUpdateBookingStatusMutation;

      const { data } = await client.mutate({
        mutation,
        variables: {
          bookingId: parseInt(bookingId),
          bookingStatus,
          driverId: driverId || null
        }
      });

      if (data?.adminUpdateBookingStatus?.status === 200) {
        toastr.success('Success', `Booking status has been updated successfully.`);
        return {
          status: 200
        };
      } else {
        errorMessage = (data && data.adminUpdateBookingStatus && data.adminUpdateBookingStatus.errorMessage) || "Oops! Something went wrong. Please try again.";
        toastr.error('Error!', errorMessage);
        return {
          status: 400
        };
      }
    } catch (err) {
      console.error(err);
      toastr.error('Error!', 'Something went wrong');
      return {
        status: 400
      };
    }

  }
};
